// extracted by mini-css-extract-plugin
module.exports = {"download_icon":"ExcelDownload_download_icon__1EZzN","download_btn":"ExcelDownload_download_btn__BzJK-"};